import { Tooltip } from "@mui/material";
import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "flex items-center justify-center rounded-[4px] cursor-pointer",
    text: "font-semibold",
  },
  variants: {
    size: {
      "default": { bg: "w-7 h-7" },
      "autowidth": { bg: "w-auto h-7 px-2" }
    },
    textSize: {
      "default": {
        text: "text-base",
      },
      "small": {
        text: "text-xs",
      },
      "verySmall": {
        text: "text-[0.70rem]",
      },
    },
  }
})()

/**
 * CustomItemStatus
 */

interface Props {
  bgColor: string;
  title: string;
  description: string;
  width?: string;
  size?: "default" | "autowidth";
  textSize?: "default" | "small" | "verySmall";
}

function CustomItemStatus({ bgColor, title, description, width, size = "default", textSize = "default" }: Props) {
  return (
    <>
      <Tooltip title={description}>
        <div className={bg({ size: size })} style={{ width, backgroundColor: bgColor }}>
          <h1
            className={text({ textSize: textSize })}
            style={{ color: 'white', textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}>
            {title}
          </h1>
        </div>
      </Tooltip>
    </>
  );
}

export default CustomItemStatus;